import React from "react";
import Skills from "../components/Skills";

function HomePage() {
    return (
        <div className="container" id="Home">
            <div className="container-small align-left">
                <div className="hero-block">
                    <h1 className="hero-heading">BSc in Civil Engineering</h1>
                    <div className="text-lead">University of the Witwatersrand in ☂ Johannesburg.</div>
                </div>
            </div>
            <div className="block-divider"></div>
            <div className="section-block">
                <div className="content-title-wrap">
                    <div className="content-title-dot"></div>
                    <h2 className="content-title">Civil Engineering Skills.</h2>
                    <div className="content-title is-text">
                        (2021 ~ Present*)
                    </div>
                </div>
                <div className="content-title-wrap">
                    <div className="content-title-dot"></div>
                    <h2 className="content-title">Mobile App Development.</h2>
                    <div className="content-title is-text">
                        (2018 ~ Present*).
                    </div>
                </div>
                <div className="content-title-wrap">
                    <div className="content-title-dot"></div>
                    <h2 className="content-title">Web App Development.</h2>
                    <div className="content-title is-text">(2020 ~ Present*)</div>
                </div>
            </div>
            {/*<div className="block-divider"></div>*/}
            {/*<div className="section-block">*/}
            {/*    <div className="content-title-wrap">*/}
            {/*        <div className="content-title-dot"></div>*/}
            {/*        <h2 className="content-title">Mobile App Development.</h2>*/}
            {/*        <div className="content-title is-text">*/}
            {/*            (2018 ~ Present*).*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*</div>*/}
            {/*<div className="block-divider"></div>*/}
            {/*<div className="section-block">*/}
            {/*    <div className="content-title-wrap">*/}
            {/*        <div className="content-title-dot"></div>*/}
            {/*        <h2 className="content-title">Web App Development.</h2>*/}
            {/*        <div className="content-title is-text">(2020 ~ Present*)</div>*/}
            {/*    </div>*/}
            {/*</div>*/}
        </div>
    )
}

export default HomePage